import { Component, OnInit } from "@angular/core";
import { Brand } from "../../../Models/brand";
import { ActivatedRoute, ParamMap, Params, Router } from "@angular/router";
import { switchMap, switchMapTo, tap } from "rxjs/operators";
import { BrandService } from "../../../Services/brand.service";

@Component({
    selector: "app-brand-filter",
    templateUrl: "./brand-filter.component.html",
    styleUrls: ["./brand-filter.component.scss"],
    standalone: false
})
export class BrandFilterComponent implements OnInit {
  selectedSubCategories: any;
  selectedCategoryId: any;

  brandExpanded = false;

  brands?: Brand[] = [];
  selectedBrands: number[] = [];
  error = false;
  inStock: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private brandService: BrandService
  ) {
    this.route.paramMap
      .pipe(
        tap((params: ParamMap) => {
          this.selectedCategoryId = Number(params.get("id"));
          this.selectedSubCategories = [this.selectedCategoryId];
        }),
        switchMapTo(this.route.queryParams),
        switchMap((params: Params) => {
          if (params.hasOwnProperty("categories")) {
            this.selectedSubCategories = [params.categories];
          } else if (
            params.hasOwnProperty("subCategory") &&
            !params.hasOwnProperty("categories")
          ) {
            this.selectedSubCategories = [params.subCategory];
          }
          if (params.hasOwnProperty("inStock")) {
            this.inStock = params.inStock;
          }
          return this.brandService.getByCategoryId(
            this.selectedSubCategories,
            this.inStock
          );
        })
      )
      .subscribe(
        (response) => (this.brands = response),

        () => (this.error = true)
      );

    this.route.queryParamMap.subscribe(
      (params: ParamMap) =>
        (this.selectedBrands = params.getAll("brands").map(Number))
    );
  }

  ngOnInit() {}

  applyFilter() {
    const params: Params = { brands: this.selectedBrands };

    this.router.navigate(["./"], {
      relativeTo: this.route,
      queryParams: params,
      queryParamsHandling: "merge",
    });
  }
}
